export const humanDate = (isoDate?: string | null) => (isoDate ? new Date(isoDate).toLocaleDateString() : "");
export const humanDateToTime = (isoDate: string | null) => {
    if (isoDate === null || isoDate === '') return 0;
    var dateParts = isoDate.split("/");
    // month is 0-based, that's why we need dataParts[1] - 1
    var dateObject = new Date(+dateParts[2], Number(dateParts[1]) - 1, +dateParts[0]);
    return dateObject.getTime();
};
